<template>
  <span
    class="aft-translation -vue"
    :data-key="name"
    v-html="_t(name, defaultValue).value"
  >
  </span>
</template>

<script setup>
import { useTranslation } from "./useTranslations";

const { name, default: defaultValue } = defineProps({
  name: { type: String, required: true },
  default: { type: String, required: true },
});

const { _t } = useTranslation();
</script>
